"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_COUNTRY_RESTRICTION = void 0;
exports.CREATE_COUNTRY_RESTRICTION = {
    DUPLICATE_COUNTRY_ISO_CODE: {
        messageLangMap: {
            "EN-US": "A restriction for this country is already registered.",
            'PT-BR': 'Já existe uma restrição para esse país.',
        },
        type: 'DUPLICATE_COUNTRY_ISO_CODE',
        usecase: 'CREATE_COUNTRY_RESTRICTION',
    },
};
